var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",style:({
  width: (_vm.percent + "%"),
  height: _vm.height,
  opacity: _vm.show ? 1 : 0,
  'background-color': _vm.canSuccess ? _vm.color : _vm.failedColor
})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c15430d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Loading.vue
// module id = DgbG
// module chunks = 53